import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items, dark = false }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-6">
      <ol className={`flex flex-wrap items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.15em] ${dark ? "text-slate-400" : "text-steel"}`}>
        <li>
          <Link to="/" className="transition-colors hover:text-accent">Home</Link>
        </li>
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight size={11} className="opacity-50" />
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-accent">{item.label}</Link>
            ) : (
              <span className={dark ? "text-slate-200" : "text-ink"} aria-current="page">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [{ "@type": "ListItem", position: 1, name: "Home", item: "https://stjinnovations.com" },
    ...items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 2,
      name: it.label,
      ...(it.to ? { item: `https://stjinnovations.com${it.to}` } : {}),
    }))],
});
